export default "__VITE_ASSET__cEdM3YO$__"